// extracted by mini-css-extract-plugin
export default {"item":"DropdownMenuItems_item__Gdand","item__text":"DropdownMenuItems_item__text__EjHF4"};